<script setup lang="ts">
const {activeButtonsCount = 0} = defineProps<{
  activeButtonsCount?: number
}>()
</script>

<template>
  <aside
    class="fixed bottom-0 grid grid-cols-2 gap-4 rounded-full border border-stone-700/50 bg-white/80 px-4 py-1 text-[10px] text-stone-400 transition-transform md:text-xs"
    :class="activeButtonsCount > 0 ? 'scale-120' : 'scale-100'"
  >
    <span>Gleicher Ton auf:</span>
    <div class="grid grid-cols-2 gap-4">
      <div class="flex items-center gap-1">
        <div class="h-2 w-2 rounded-full bg-emerald-500 shadow-[0_0_5px_rgba(16,185,129,0.8)]" />
        Druck
      </div>
      <div class="flex items-center gap-1">
        <div class="h-2 w-2 rounded-full bg-blue-500 shadow-[0_0_5px_rgba(59,130,246,0.8)]" />
        Zug
      </div>
    </div>
  </aside>
</template>
